import {useEffect} from "react";
import {useForm, Controller, useWatch} from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import Button from "~/components/Button";
import Loading from "~/components/Loading";
import {
	GroupRadioField,
	TextAreaField
} from "~/components/Forms";

const statusOptions = [
	{ value: 'resolved', label: 'Đã xác định (loại khỏi báo cáo chờ)'},
	{ value: 'pending', label: 'Chờ xác định'},
];

function PendingReceiptFormResolve({item, onHandleResolve}) {

	const initialValues = {
		status: 'resolved',
		resolvedNote: '',
	}

	const validationSchema = Yup.object().shape({
		status: Yup.string().required('Bạn chưa chọn trạng thái'),
		resolvedNote: Yup.string().when('status', {
			is: 'resolved',
			then: Yup.string().required('Vui lòng ghi chú khoản này thuộc nguồn/hợp đồng nào'),
		}),
	});

	const { control, handleSubmit, formState: { isSubmitting, errors }, reset } = useForm({
		defaultValues: initialValues,
		resolver: yupResolver(validationSchema)
	});

	const status = useWatch({ control, name: 'status' });

	useEffect(() => {
		if(item?.id) {
			initialValues.status = item.status?.key === 'resolved' ? 'pending' : 'resolved';
			initialValues.resolvedNote = item.resolvedNote || '';
		}
		reset(initialValues);
	}, [item]);

	const onSubmit = async (data) => {
		await onHandleResolve({...data, id: item.id});
	}

	return (
		<form className="form" onSubmit={handleSubmit(onSubmit)}>
			{isSubmitting && <Loading/>}
			<p className="heading">Xác định nguồn khoản thu <b>TCD{item?.id}</b></p>
			<Controller control={control} name="status" render={({ field }) => (
				<GroupRadioField label="Trạng thái" options={statusOptions} errors={errors} {...field}/>
			)}/>
			{status === 'resolved' && (
				<Controller control={control} name="resolvedNote" render={({ field }) => (
					<TextAreaField label="Ghi chú nguồn (thuộc hợp đồng / khách hàng nào)" errors={errors} {...field} />
				)}/>
			)}
			<hr />
			<div className="form-group d-flex justify-content-end modal-bottom">
				<Button primary type="submit">Lưu trạng thái</Button>
			</div>
		</form>
	)
}

export default PendingReceiptFormResolve;
